import { Component, OnInit} from '@angular/core';
import { RestService } from 'src/app/datasource/rest.service';
import flatpickr from "flatpickr";

@Component({
  selector: 'app-raports',
  templateUrl: './raports.component.html',
  styleUrls: ['./raports.component.less']
})
export class AppsRaportsComponent implements OnInit {
  public method = "apps/index/format/json/";
  public list = [];

  constructor(private RService: RestService) { }

  ngOnInit(): void {
    flatpickr(".date_picker", {mode:"range"});
    this.RService.get(this.method).subscribe((response: any) => {
    if (response.status === true) {
        this.list = response.result;
      }
    });
  }

}
